<template>
    <div class="buyedCourse">
          <Navbar title="已购课程"   />

          <div class="notHave" v-if="listLength===0">
              <img src="../../assets/images/reading.png" alt="">
              <div>暂无已购课程，快去购买课程吧~</div>
          </div>
           
            <div class='courseList' v-else>

                 <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check='false'
                finished-text="没有更多了"
                @load="onLoad"
              >

                <div class="courseCard" v-for="(item,index) in list" :key="index">
                     <div class="coursePoster">
                         <img :src="item.cover" alt="">
                     </div>

                     <div class="cardRight">
                          <div class="courseTitle">{{item.name}}</div>
                          <div class="learnNum">{{item.title}}</div>

                          <div class="courseBt">
                              <div class="teacherInfo">
                                  <img :src="item.teacherAvatar" alt="">
                                  <div class="teachername">{{item.teacherName}}</div>
                              </div>

                              <div class='learnBt' @click="toLearn(item.id)">开始学习</div>
                          </div>
                     </div>
                </div>

                 </van-list>
         </van-pull-refresh>
            </div>
    </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
import { Toast } from 'vant';
export default {
  data() {
    return {
      list: [],
      listLength:'',
      loading: false, //是否正在加载
      finished: false, //是否结束
      refreshing: false, //是否正在刷新
      current: 1,
      size: 20
    };
  },
  components: {
    Navbar
  },
  mounted() {
    // Toast('1')
    this.getBoughtCourses();
  },
  activated(){
    this.current=1
    this.getBoughtCourses()
  },
  methods: {
    getBoughtCourses() {
      //获取速成课已购课程列表
      http
        .getAlreadyBoughtCourse({
          current: this.current,
          size: this.size,
          type: 3
        })
        .then(res => {
         
          setTimeout(() => {
            // Toast(res.length)
            if (res.length > 0) {

              if (this.refreshing||this.current==1) {
                this.list = [...res];
                this.refreshing = false;
              } else {
                this.list = [...this.list, ...res];
              }
              this.loading = false;
            } else {
              this.finished = true;
              this.current--;
            }
           this.listLength= this.list.length
          }, 200);
          console.log(res);
        });
    },
    onLoad() {
       if(this.refreshing){
       
      }else{
        this.current++
      }
 
      this.getBoughtCourses()
    },
      toLearn(id){
        
           this.$router.push({
              path:'/SpeedStudyIntro',
              query:{id,type:3}
          })         
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.current=1
      this.onLoad();
    }
  }
};
</script>

<style lang="less" scoped>
.buyedCourse {
  width: 100%;
  min-height: 100vh;
  .notHave {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    img {
      width: 225px;
      height: 116px;
    }

    div {
      font-size: 15px;
      color: rgba(34, 32, 48, 0.45);
      margin-top: 32px;
    }
  }

  .courseList {
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-top: 12px;
    .courseCard {
      display: flex;
      width: 100%;
      background: #f6f6f6;
      border-radius: 6px 6px 6px 6px;
      overflow: hidden;
      height: 100px;
      margin-bottom: 8px;

      .coursePoster {
        img {
          width: 100px;
          object-fit: cover;
          height: 100px;
        }
      }
      .cardRight {
        margin-left: 8px;
        flex: 1;
        padding-right: 16px;
        box-sizing: border-box;
      }
      .courseTitle {
        color: #222030;
        font-size: 15px;
        font-weight: bold;
        margin-top: 12px;
      }
      .learnNum {
        font-size: 12px;
        color: rgba(34, 32, 48, 0.45);
        margin-top: 4px;
      }
      .courseBt {
        display: flex;
        justify-content: space-between;
        //   align-items: center;
        //   margin-top: 6px;

        .teacherInfo {
          display: flex;
          align-items: center;
          margin-top: 17px;
          img {
            width: 20px;
            height: 20px;
            object-fit: cover;
            border-radius: 50%;
          }
          .teachername {
            font-size: 12px;
            color: rgba(34, 32, 48, 0.65);
          }
        }

        .learnBt {
          width: 72px;
          margin-top: 6px;
          height: 28px;
          background: linear-gradient(135deg, #ff7337 0%, #fc541e);
          border-radius: 6px;
          font-size: 13px;
          color: #ffffff;
          text-align: center;
          line-height: 29px;
        }
      }
    }
  }
}
</style>

